import React from "react";
import StoryLayout from "./StoryLayout";
import { AlertOctagon, Clock, TrendingDown } from "lucide-react";

export default function StoryAmendment() {
    return (
        <StoryLayout
            slideNumber={3}
            eyebrow="Protocol Amendment v2.2 · pending IRB"
            nextTo="/icf/extract?story=1"
            prevTo="/icf/story/setup"
            nextLabel="Watch AudRI do it"
            testid="story-amendment"
        >
            <div className="grid grid-cols-1 lg:grid-cols-[minmax(0,1fr)_minmax(0,1fr)] gap-10 items-start">
                {/* Left — the amendment doc */}
                <div>
                    <h1 className="heading text-3xl md:text-4xl font-medium tracking-tighter leading-tight">
                        A single paragraph.
                        <br />
                        <span className="text-[#C2410C]">
                            A whole quarter of work.
                        </span>
                    </h1>

                    <div className="mt-8 border border-hair bg-white p-6 md:p-8">
                        <div className="flex items-center justify-between mb-4">
                            <div>
                                <div className="overline text-[9px]">
                                    Protocol Amendment v2.2
                                </div>
                                <div className="mono text-[11px] text-neutral-500 mt-1">
                                    Meridian Oncology · ONCO-247
                                </div>
                            </div>
                            <span className="mono text-[10px] uppercase tracking-wider px-2 py-[2px] border rounded-sm text-[#9A3412] bg-[#FFEDD5] border-[#FED7AA]">
                                Pending IRB
                            </span>
                        </div>
                        <div className="border-t border-hair pt-5">
                            <div className="text-[11px] mono uppercase tracking-wider text-neutral-400 mb-3">
                                § 4.7 · Biomarker sub-study
                            </div>
                            <p className="text-[13.5px] leading-relaxed text-neutral-800">
                                At Study Visits 3, 5, and 7 an additional{" "}
                                <span className="bg-[#FFEDD5] px-1 rounded-sm">
                                    10 mL peripheral blood sample
                                </span>{" "}
                                will be collected for pharmacogenomic analysis.
                                Participation is optional. Specimens will be
                                retained for up to 10 years for future research
                                use.
                            </p>
                        </div>
                    </div>
                </div>

                {/* Right — the cost cascade */}
                <div>
                    <div className="overline mb-4">
                        What that paragraph triggers
                    </div>
                    <ul className="space-y-3 text-[13px] text-neutral-700 leading-relaxed">
                        {[
                            "Every affected participant, potentially re-consented.",
                            "Every 21 CFR 50.25 element, potentially re-checked.",
                            "Your ICF, updated and re-versioned.",
                            "Your IRB packet, resubmitted for review.",
                            "12 sites, coordinated to actually re-consent people.",
                            "Sponsor QA, on the phone with each site regulatory lead.",
                        ].map((line, i) => (
                            <li
                                key={i}
                                className="flex gap-3 border-b border-hair pb-3 last:border-b-0"
                            >
                                <span className="mono text-[10px] text-neutral-400 w-5 shrink-0">
                                    {String(i + 1).padStart(2, "0")}
                                </span>
                                <span>{line}</span>
                            </li>
                        ))}
                    </ul>

                    <div className="mt-8 border border-[#FCA5A5] bg-[#FEF2F2] p-5 rounded-sm">
                        <div className="flex items-center gap-2 overline text-[#991B1B] mb-3">
                            <TrendingDown size={11} /> Industry cycle time
                        </div>
                        <div className="heading text-2xl font-medium tracking-tight text-[#991B1B] leading-tight">
                            3–5 business days per participant
                            <br />
                            × 87 participants =
                            <br />
                            most of a quarter.
                        </div>
                        <div className="border-t border-[#FCA5A5] mt-4 pt-3 flex items-start gap-2 text-[11.5px] text-[#7F1D1D] leading-relaxed">
                            <AlertOctagon
                                size={12}
                                className="mt-[3px] shrink-0"
                            />
                            <span>
                                <strong>Failure mode:</strong> one missed
                                re-consent → BIMO finding → protocol deviation
                                → your amendment slips a milestone.
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </StoryLayout>
    );
}
